module.exports = __webpack_public_path__ + "img/mb-warn.c203d84d.svg";